<template>
  <div class="headlines-container">
    <v-container v-if="category === 'BettingHeadlines' && (currentBoNavigationHeadlines && currentBoNavigationHeadlines.length > 0)" fluid :class="['headlines']">
      <div class="headline-big" v-if="!mobileBigAndBelow">
        <v-carousel :interval="rotationInterval" :style="{'height': this.carouselHeight}" hide-delimiters :cycle="cycleRotation">
          <v-carousel-item @notify="setIndex" @click.native="goToHeadlineLink(headline)" v-for="(headline, index) in currentBoNavigationHeadlines" :key="index"
            style="height: auto; min-height:280px;" :class="[{'active': headline.idfwheadline === selectedTab.idfwheadline}, {'hover-headline': headline.location !== null}]"
            :src="headline.imageurl">
          </v-carousel-item>
        </v-carousel>
      </div>
      <!-- <div class="headline-mobile" v-if="mobileBigAndBelow && initHeadlineMobile"> -->
      <div class="headline-mobile" v-if="mobileBigAndBelow">
        <!-- <v-carousel delimiter-icon="remove" :style="{'height': this.carouselHeight}" style="min-height:220px" hide-controls> -->
        <v-carousel :class="{'mobile' : mobile}" hide-controls>
          <v-carousel-item @click.native="goToHeadlineLink(headline)" v-for="(headline, index) in currentBoNavigationHeadlines" :key="index"
              style="height: 100%; background-size: contain;background-position: center;"
              :style="{backgroundImage: 'url(' + headline.imageurl + ')'}"
              >
          </v-carousel-item>
        </v-carousel>
      </div>
    </v-container>
    <div v-if="category === 'BettingHeadlines' && (!currentBoNavigationHeadlines || currentBoNavigationHeadlines.length === 0)">
        <!-- <sports-breadcrumb></sports-breadcrumb> -->
    </div>
    <v-container v-if="category === 'SidebarBanners' && (currentBoNavigationHeadlines && currentBoNavigationHeadlines.length > 0)" fluid :class="['headlines']">
      <div class="headline-big" v-if="!mobileBigAndBelow">
        <v-carousel :interval="rotationInterval" :style="{'height': this.carouselHeight}" hide-delimiters :cycle="cycleRotation" hide-controls>
          <v-carousel-item @notify="setIndex" @click.native="goToHeadlineLink(headline)" v-for="(headline, index) in currentBoNavigationHeadlines" :key="index"
            style="height: auto; min-height:280px;" :class="[{'active': headline.idfwheadline === selectedTab.idfwheadline}, {'hover-headline': headline.location !== null}]"
            :src="headline.imageurl">
          </v-carousel-item>
        </v-carousel>
      </div>
    </v-container>
  </div>
</template>
<script>
  import store from '@/store'
  import Screen from '@/components/mixins/Screen'
  import BettingOffer from '@/components/mixins/BettingOffer'
  import SportsBreadcrumb from '@/components/sports/bettingoffer/SportsBreadcrumb'
  import mobileBridge from '@/library/mobileBridge'

  export default {
    name: 'headlines',

    props: [
      'category',
      'isplain',
      'isempty'
    ],
    mixins: [
      Screen,
      BettingOffer
    ],

    components: {
      SportsBreadcrumb
    },

    data () {
      return {
        selectedTabIdFwHeadline: -1,
        rotationIndex: 0,
        rotationInterval: 6000,
        circularRotateProgres: false,
        currentidfwheadline: 0,
        carouselHeight: 0,
        isRotationStartedWhenHeadlineSnapped: false,
        cycleRotation: false,
        initHeadlineMobile: null,
        headlineDelay: 0
      }
    },

    computed: {
      currentidfwbonavigation () {
        var currentidfwbonavigation = this.idfwbonavigation2 || this.idfwbonavigation1 || null

        if (currentidfwbonavigation && !isNaN(currentidfwbonavigation)) {
          return parseFloat(currentidfwbonavigation)
        } else {
          return currentidfwbonavigation
        }
      },
      headlines () {
        return store.getters['bonavigationState/boNavigationHeadlines']
      },
      // currentBoNavigationHeadlines () {
      //   if (this.category === 'BettingHeadlines' || this.category === 'SidebarBanners') {
      //     var sort = this.headlines && this.headlines.filter(hl => hl.categoryname === this.category && hl.idfwbonavigation === this.currentidfwbonavigation)
      //     return sort
      //   }
      // },
      strIdfwbonavigation1 () {
        var currentidfwbonavigation = this.idfwbonavigation1
        if (currentidfwbonavigation && !isNaN(currentidfwbonavigation)) {
          return parseFloat(currentidfwbonavigation)
        } else {
          return currentidfwbonavigation
        }
      },
      strIdfwbonavigation2 () {
        var currentidfwbonavigation = this.idfwbonavigation2
        if (currentidfwbonavigation && !isNaN(currentidfwbonavigation)) {
          return parseFloat(currentidfwbonavigation)
        } else {
          return currentidfwbonavigation
        }
      },
      currentBoNavigationHeadlines () {
        if (this.category === 'BettingHeadlines' || this.category === 'SidebarBanners') {
          var sort = this.headlines && this.headlines.filter(hl => hl.categoryname === this.category && hl.idfwbonavigation === this.strIdfwbonavigation2)
          if (sort.length === 0) {
            sort = this.headlines && this.headlines.filter(hl => hl.categoryname === this.category && hl.idfwbonavigation === this.strIdfwbonavigation1)
            if (sort.length === 0) {
              sort = this.headlines && this.headlines.filter(hl => hl.categoryname === this.category && !hl.idfwbonavigation)
            }
          }
          return sort
        }
      },
      selectedTab () {
        return this.currentBoNavigationHeadlines.filter(item => item.idfwheadline === this.selectedTabIdFwHeadline)[0] ||
          (this.currentBoNavigationHeadlines && this.currentBoNavigationHeadlines.length > 0 && this.currentBoNavigationHeadlines[0]) || undefined
      },
      headerSettings () {
        return store.getters['screenState/getHeaderMessageHeight']
      },
      isOpenedFromWebView () {
        return store.getters['getIsOpenedFromWebView']
      },
      router () {
        return this.$route.name
      }
    },

    methods: {
      selectTab (idfwheadline) {
        for (let i = 0; i < this.currentBoNavigationHeadlines.length; i++) {
          if (this.currentBoNavigationHeadlines[i].idfwheadline === idfwheadline) {
            this.rotationIndex = i
          }
        }
        this.selectedTabIdFwHeadline = idfwheadline
        this.currentidfwheadline = idfwheadline
      },
      selectTabOnClick (idfwheadline, tabId) {
        // prevent click on active tab and stop Rotation
        if (idfwheadline !== this.currentidfwheadline) {
          this.stopRotation()
          this.selectTab(idfwheadline)
          this.selectBanner(tabId)
        }
      },
      goToHeadlineLink (headline) {
        switch (headline.idfwheadlinetype) {
          case 'MKPB':
            switch (headline.linktype) {
              case 'URL':
                if (headline.location) {
                  if (headline.location.indexOf('http://') > -1 || headline.location.indexOf('https://') > -1) {
                    window.location = headline.location
                  } else {
                    if (headline.location.indexOf('/') !== 0) {
                      headline.location = '/' + headline.location
                    }
                    location.href = headline.location
                  }
                }
                break
              case 'EXTERNAL':
                if (headline.location) {
                  if (headline.location.indexOf('http://') > -1 || headline.location.indexOf('https://') > -1) {
                    if (this.mobileBigAndBelow && this.isOpenedFromWebView) {
                      mobileBridge.openLink(headline.location)
                      return false
                    }
                    window.open(headline.location, '_blank')
                  } else {
                    if (headline.location.indexOf('/') !== 0) {
                      headline.location = '/' + headline.location
                    }
                    if (this.mobileBigAndBelow && this.isOpenedFromWebView) {
                      mobileBridge.openLink(headline.location)
                      return false
                    }
                    window.open(headline.location, '_blank')
                  }
                }
                break
              case 'BONAVIGATION':
                if (headline.location) {
                  var boNodes = headline.location.split(',') || []
                  var boNavName = 'bonavigation' + boNodes.length
                  var params = {}
                  boNodes.forEach((bonode, index) => {
                    params['idfwbonavigation' + (index + 1)] = bonode
                  })
                  this.$router.push({name: boNavName, params: params})
                }
                break
            }
            break
        }
      },
      stopRotation () {
        clearTimeout(this.rotate)
        this.rotate = false
        this.rotationIndex = 0
        this.cycleRotation = false
      },
      rotateHeadlineCarousel (scrollBack) {
        if (!this.mobileBigAndBelow) {
          this.cycleRotation = true
          if (this.currentBoNavigationHeadlines.length > 1 && !this.isplain) {
            this.circularRotateProgres = true
            if (this.rotationIndex > this.currentBoNavigationHeadlines.length - 1 || this.rotationIndex < 0) {
              this.rotationIndex = 0
            }
            this.selectTab(this.currentBoNavigationHeadlines[this.rotationIndex].idfwheadline)
            this.rotationIndex++
            this.rotate = setTimeout(this.rotateHeadlineCarousel, this.rotationInterval)
          }
        }
      },
      startRotation () {
        this.rotateHeadlineCarousel()
      },
      getCarouselHeight () {
        setTimeout(() => {
          var item = document.getElementsByClassName('v-image__image--cover')
          if (item && item.length > 0) {
            this.carouselHeight = item[0].clientHeight + 'px'
          }
          if (!this.mobileBigAndBelow) {
            this.setIndex()
          }
        }, this.headlineDelay)
      },
      setIndex () {
        var elem = document.querySelector('.v-carousel__controls')
        if (elem) {
          var btns = elem.querySelectorAll('button')
          btns.forEach(function (elem, index) {
            elem.id = 'btn-' + index
          })
        }
      },
      selectBanner (tabId) {
        let btn = document.querySelector('#btn-' + tabId)
        if (btn) {
          btn.click()
        }
      },
      delayHeadline () {
        if (this.mobileBigAndBelow && !this.isOpenedFromWebView) {
          if (this.headerSettings > 0) {
            this.initHeadlineMobile = true
          } else {
            this.initHeadlineMobile = true
          }
        }
      },
      initSlider () {
        if (this.currentBoNavigationHeadlines.length >= 1 && !this.isplain) {
          this.rotationIndex = 0
          setTimeout(() => {
            if (this.mobileBigAndBelow) {
              this.headlineDelay = 500
            }
            this.delayHeadline()
            this.startRotation()
            this.getCarouselHeight()
          }, 200)
        }
        if (this.currentBoNavigationHeadlines.length === 0 && !this.isplain) {
          this.stopRotation()
        }
      }
    },

    mounted () {
      this.initSlider()
    },

    destroyed () {
      this.stopRotation()
    },

    watch: {
      currentBoNavigationHeadlines () {
        this.cycleRotation = false
        this.initSlider()
      }
    }
  }
</script>



<!-- 18.20 -->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  @import "~@/css/config";

@media tablet-and-above
  .page-layout
    .container
      .headlines
        padding-right: 6px
        margin-bottom: 0
        @media mobile-big-and-below
          padding-right: 0
          background: #003865
        .headline-mobile
          padding-top: 5px

.v-carousel.mobile
  min-height 250px
  height 250px
.v-carousel:not(.mobile)
  min-height 450px
  height 450px

.hover-headline:hover
  cursor pointer
</style>



// WEBPACK FOOTER //
// src/components/sports/bettingoffer/headlinesLight.vue